// extracted by mini-css-extract-plugin
module.exports = {"Snackbar":"Snackbar_Snackbar__1lhda"};